import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Policies.css';

const CustomerServicePolicy: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-container">
            <button className="back-button" onClick={() => navigate(-1)}>
                ← Back
            </button>
            <h1>Customer Service Policy</h1>
            <p className="policy-intro">Last Updated: January 5, 2025</p>

            <section className="customer-service-section">
                <h2 className="section-title">Support & Assistance</h2>

                <div className="content-block">
                    <ul className="list">
                        <li>
                            For support or inquiries, please email us at{' '}
                            <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>.
                        </li>
                        <li>We strive to respond within 48 hours on business days.</li>
                    </ul>
                </div>

                <h2 className="section-title">Refunds & Subscription Cancellation</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Paid subscriptions can be canceled at any time via the Google Play or Apple App Store.</li>
                        <li>Refund requests are subject to the refund policies of these platforms.</li>
                        <li>If you experience account issues or technical problems, please contact our support team.</li>
                    </ul>
                </div>

                <h2 className="section-title">Escalation & Dispute Resolution</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>
                            If you are dissatisfied with our service, contact us via{' '}
                            <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a> to escalate your issue.
                        </li>
                        <li>We aim to resolve disputes amicably and fairly, following industry best practices.</li>
                    </ul>
                </div>
            </section>

            {/* Updates to These Policies Section */}
            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>

                <div className="content-block">
                    <p>We reserve the right to update these policies at any time.</p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of Fervoir after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p>For any questions, concerns, or feedback, please contact us at:</p>
                    <p>
                        Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default CustomerServicePolicy;